import { render } from "./petunjuk_pg_dengan_narasi.vue?vue&type=template&id=57cccc4f&scoped=true"
import script from "./petunjuk_pg_dengan_narasi.vue?vue&type=script&lang=js"
export * from "./petunjuk_pg_dengan_narasi.vue?vue&type=script&lang=js"

import "./petunjuk_pg_dengan_narasi.vue?vue&type=style&index=0&id=57cccc4f&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cccc4f"]])

export default __exports__